import { API, Auth } from 'aws-amplify'
import React, { useEffect, useState } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'; import { Table, TableCell, TableHead, TableRow, TextAreaField } from '@aws-amplify/ui-react';
import FileRow from './FileRow';
import UploadFile from "./UploadFile";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Spinner from 'react-bootstrap/Spinner';
import Documents from '../../data/documents.js';
// import { ServerlessApplicationRepository } from 'aws-sdk';

const UserFiles = (props) => {
  const projectId = props.project_id
  const [entities, setEntities] = useState([])
  const [isBusy, setIsBusy] = useState(false);
  
  console.log('DOCUMENTS')
  console.log(Documents)
  console.log('FILTER')
  console.log(Documents.filter(document => document.project_id == projectId))

  //Function to fetch from our backend and update customers array
  const getFiles = async (busy) => {
    // if (busy == true)
      setIsBusy(true);
          await sleep(2000);
    setIsBusy(false)
    setEntities(Documents.filter(document => document.project_id === projectId)) 
  };
  useEffect(() => { getFiles(true) }, [])

  const handleDelete = async (entity) => {
    setIsBusy(true);
        await sleep(2000);
    setIsBusy(false)
    setEntities(entities.filter(function(e) { 
    return e !== entity 
    }))
    // const user = await Auth.currentAuthenticatedUser()
    // const token = user.signInUserSession.idToken.jwtToken
    // const requestInfo = { headers: { Authorization: token } }

    // console.log('delete ' + entity.file_name + ' ' + entity.project_id)
    // API.get('DocumentSearchUser', '/deletefile' + `?projectid=${entity.project_id}&filename=${entity.file_name}`, requestInfo)
    //   .then(response => {
    //     setIsBusy(false);
    //     getFiles();

    //   })
    //   .catch(error => {
    //     setIsBusy(false);
    //     console.log(error)
    //   })
  };

  const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
  }

  const handleUpload = async() => {
    alert('Signup for a free account to upload your own files!')
    // await sleep(2000)
    // getFiles(false);
    // await sleep(5000)
    // getFiles(false);
  };

  return (

    <div>
      <UploadFile entities={entities} project_id={projectId} onUpload={handleUpload} />      
      <Row>
        <Col>
          {isBusy &&
            <Spinner animation="border" role="status" variant="primary">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          }
        </Col>
      </Row>
      <Table className='table table-striped'>
        <TableHead>
          <TableRow>
            <TableCell><strong>#</strong></TableCell>
            <TableCell><strong>Document Name</strong></TableCell>
            <TableCell><strong>Format</strong></TableCell>
            <TableCell><strong>Pages</strong></TableCell>
            <TableCell><strong>Size</strong></TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>

        <tbody>
          {
            entities.map((thisEntity, index) => {
              return (

                <FileRow key={thisEntity.id} entity={thisEntity} onDelete={handleDelete} index={index + 1} />
              )
            })
          }
        </tbody>
      </Table>
    </div>
  )
}
export default UserFiles;